import { CheckCircle, Monitor, Wifi } from "lucide-react";

const DVDifferenceSection = () => {
  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold mb-8">Understanding D vs DV Models</h2>
      <div className="grid gap-6 md:grid-cols-2">
        {/* D Model */}
        <div className="bg-card rounded-lg p-8 border shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <Wifi className="h-8 w-8 text-[#069E50]" />
            <h3 className="text-xl font-semibold">RXT-4D / RXT-6D <span className="text-muted-foreground font-normal text-base">— Standard</span></h3>
          </div>
          <p className="text-muted-foreground mb-4">
            The <strong>D models</strong> are powerful touch panel control systems with Dante™ audio networking. They do <strong>not</strong> include an integrated AV over IP transmitter, but they offer something unique:
          </p>
          <ul className="space-y-2">
            <li className="flex items-start gap-2">
              <CheckCircle className="h-4 w-4 text-[#069E50] mt-0.5 flex-shrink-0" />
              <span className="text-sm text-muted-foreground"><strong>RTSP stream support</strong> — accept and display real-time camera streams directly on the panel</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle className="h-4 w-4 text-[#069E50] mt-0.5 flex-shrink-0" />
              <span className="text-sm text-muted-foreground">Full ReAX™ control system with Dante™/AES67 audio</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle className="h-4 w-4 text-[#069E50] mt-0.5 flex-shrink-0" />
              <span className="text-sm text-muted-foreground">Ideal when AV over IP is not required but camera monitoring is needed</span>
            </li>
          </ul>
        </div>

        {/* DV Model */}
        <div className="bg-gradient-to-br from-[#069E50]/10 to-[#069E50]/5 rounded-lg p-8 border border-[#069E50]/20 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <Monitor className="h-8 w-8 text-[#069E50]" />
            <h3 className="text-xl font-semibold">RXT-4DV / RXT-6DV <span className="text-muted-foreground font-normal text-base">— With VPX AVoIP</span></h3>
          </div>
          <p className="text-muted-foreground mb-4">
            The <strong>DV models</strong> include everything in the D models <strong>plus</strong> an integrated <strong>VPX 1Gbps 4K60 AV over IP transmitter</strong>, transforming them into content distribution powerhouses:
          </p>
          <ul className="space-y-2">
            <li className="flex items-start gap-2">
              <CheckCircle className="h-4 w-4 text-[#069E50] mt-0.5 flex-shrink-0" />
              <span className="text-sm text-muted-foreground"><strong>Integrated VPX 1Gbps 4K60 AVoIP engine</strong> — transmit content across the network</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle className="h-4 w-4 text-[#069E50] mt-0.5 flex-shrink-0" />
              <span className="text-sm text-muted-foreground"><strong>USB-C & Mini-HDMI inputs</strong> with USB-C display output</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle className="h-4 w-4 text-[#069E50] mt-0.5 flex-shrink-0" />
              <span className="text-sm text-muted-foreground"><strong>USB-C 100W power pass-through</strong> for laptop charging</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle className="h-4 w-4 text-[#069E50] mt-0.5 flex-shrink-0" />
              <span className="text-sm text-muted-foreground">Full VPX AVOIP ecosystem compatibility</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DVDifferenceSection;
